import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { Params, RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faPaperPlane, faPen } from '@fortawesome/pro-light-svg-icons';
import { JobDetail } from '../../../interfaces/job-detail';
import { PlatformAuthService } from '../../../platform/services/platform-auth.service';
import { PlatformApplyWithProfileService } from '../../../platform/services/platform-apply-with-profile.service';
import { PlatformJobsService } from '../../../platform/services/platform-jobs.service';

@Component({
  selector: 'app-job-apply-actions',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, TranslocoPipe, FaIconComponent],
  templateUrl: './job-apply-actions.component.html',
  styleUrl: './job-apply-actions.component.scss',
})
export class JobApplyActionsComponent {
  private readonly auth = inject(PlatformAuthService);
  private readonly applyModal = inject(PlatformApplyWithProfileService);
  private readonly jobs = inject(PlatformJobsService);

  readonly job = input.required<JobDetail>();
  readonly applyLink = input.required<readonly (string | number)[]>();
  readonly applyQueryParams = input<Params | null>(null);
  readonly applyTarget = input<string | null>(null);

  readonly loggedIn = this.auth.loggedIn;
  readonly icons = {
    apply: faPaperPlane,
    pen: faPen,
  };

  readonly hasApplied = computed(() =>
    this.jobs.hasAppliedToJobboardJob(this.job())
  );

  /**
   * Opens the apply-with-profile modal for the current job.
   */
  openApplyWithProfile(): void {
    this.applyModal.open(this.jobs.applyContextFromJobboardJob(this.job()));
  }
}
